
if (window.matchMedia( "(max-width: 767px)" ).matches) {
  /* ウィンドウサイズが 768px以下の場合のコードをここに */
  $(".main-carousel").flickity({
    contain: true,
    autoPlay: true,
    pageDots: true,
    wrapAround: true,
    prevNextButtons: false,
    groupCells: 1
  });

  $(".top-vanson").flickity({
    contain: true,
    autoPlay: true,
    pageDots: true,
    wrapAround: true,
    prevNextButtons: false,
    groupCells: 1
  });

  
  } else {
  /* ウィンドウサイズが 768px以上の場合のコードをここに */
  $(".main-carousel").flickity({
    cellAlign: "left",
    contain: true,
    autoPlay: true,
    pageDots: true,
    wrapAround: true,
    prevNextButtons: false,
    groupCells: 1
  });

  $(".top-vanson").flickity({
    cellAlign: "left",
    contain: true,
    autoPlay: true,
    pageDots: true,
    wrapAround: true,
    prevNextButtons: false,
    groupCells: 1
  });
  
  }






//ドロップダウンの設定を関数でまとめる
function mediaQueriesWin(){
  var width = $(window).width();
  if(width <= 768) {//横幅が768px以下の場合
    $(".has-child>a").off('click'); //has-childクラスがついたaタグのonイベントを複数登録を避ける為offにして一旦初期状態へ
    $(".has-child>a").on('click', function() {//has-childクラスがついたaタグをクリックしたら
      var parentElem =  $(this).parent();// aタグから見た親要素の<li>を取得し
      $(parentElem).toggleClass('active');//矢印方向を変えるためのクラス名を付与して
      $(parentElem).children('ul').stop().slideToggle(500);//liの子要素のスライドを開閉させる※数字が大きくなるほどゆっくり開く
      return false;//リンクの無効化
    });
  }else{//横幅が768px以上の場合
    $(".has-child>a").off('click');//has-childクラスがついたaタグのonイベントをoff(無効)にし
    $(".has-child>a").removeClass('active');//activeクラスを削除
    $('.has-child').children('ul').css("display","");//スライドトグルで動作したdisplayも無効化にする
  }
}

// ページがリサイズされたら動かしたい場合の記述
$(window).resize(function() {
  mediaQueriesWin();/* ドロップダウンの関数を呼ぶ*/
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load',function(){
  mediaQueriesWin();/* ドロップダウンの関数を呼ぶ*/
});

$(document).ready(function(){
   $('.main_img_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow:"<button type='button' class='slidebtn2 slick-prev pull-left'><i class='fal fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slidebtn2 slick-next pull-right'><i class='fal fa-angle-right' aria-hidden='true'></i></button>",
    //fade: true,
    dots: false,
    asNavFor: '.thumb_pdp_slider',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true
        }
      }
    ]
  });
  $('.thumb_pdp_slider').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: false,
    vertical: true,
    asNavFor: '.main_img_slider',
    dots: false,
    arrows: true,
    prevArrow:"<button type='button' class='slidebtn slick-prev pull-left'><i class='fas fa-chevron-up'></i></button>",
    nextArrow:"<button type='button' class='slidebtn slick-next pull-right'><i class='fas fa-chevron-down'></i></button>",
    centerMode: false,
    focusOnSelect: true
  });
  
    $('header nav .has-child').click(function(){
    if ($(this).hasClass("active")) {
      $(this).removeClass('active');
    }
    else{
      $('header nav .has-child').removeClass('active');
      $(this).toggleClass('active');
    }
    
    
  });

  /*
  $('.sidemenu .level1').addClass("active");
  $('body').on('click', '.sidemenu .level1', function(){
    if ($(this).hasClass("active")) {
      $(this).removeClass('active');
      $(this).children('ul').slideUp('slow');
    }
    else{
      $('.sidemenu .level1').removeClass('active');
      $(this).addClass('active');
        $('.sidemenu .level1 ul').not('.active ul').slideUp('slow');
      $('.sidemenu .level1.active').children("ul").slideDown('slow');
    }
   
  });
  */
  
  function changeMainImage() {
    /*var vTitle = $("#productSelect").children("option[value='"+val+"']").attr("variant_image");
    console.log(vTitle);
    var ind = $(".main_img_slider img[src='"+vTitle+"']").index();*/
    
    var values = "";
    $(".variant-swatch").each(function(index){
      if(values != "") {
        values = values + "/" + $(this).children("li.active").data("value");
      }
      else {
        values = $(this).children("li.active").data("value");
      }
    });
    console.log(values);
    var vTitle = $("#productSelect").children("option[data-title='"+values+"']").attr("variant_image");
    
    var ind = $(".main_img_slider img[src='"+vTitle+"']").index();
    if(ind > -1) {
    	$('.main_img_slider').slick('slickGoTo', ind );
    }
  }
  
  $("body").on("change", "#productSelect", function(){
    
  });
  changeMainImage();
  
  function setSoldOut(){
    if($(".variant-swatch").length > 1) {
      var v1 = $(".variant-swatch.swatch-1 li.active").data("value");
      $(".variant-swatch.swatch-2 li").each(function(){
        var vs = v1 + "/" + $(this).data("value");
        
        if($("#productSelect option[data-title='"+vs+"']").attr("disabled")) {
          $(this).removeClass("active").addClass("disabled");
        }
        else {
          $(this).removeClass("disabled");
        }
      });
    }
    else {
      $(".variant-swatch.swatch-1 li").each(function(){
        if($("#productSelect option[data-title='"+v1+"']").attr("disabled")) {
          $(this).removeClass("active").addClass("disabled");
        }
        else {
          $(this).removeClass("disabled");
        }
      });
    }
  }
  if($(".variant-swatch").length > 0) {
    setSoldOut();
  }
  $("body").on("click", ".variant-swatch li", function(){
    setSoldOut();
    if(!$(this).hasClass("active")) {
      if(!$(this).hasClass("soldout")) {
        $(this).parent().children("li").removeClass("active");
        $(this).addClass("active");
        var values = "";
        $(".variant-swatch").each(function(index){
          if(values != "") {
              values = values + "/" + $(this).children("li.active").data("value");
          }
          else {
            values = $(this).children("li.active").data("value");
          }
        });
        var varId = $("#productSelect option[data-title='"+values+"']").attr("value");
        var var_price = $("#productSelect option[data-title='"+values+"']").data("price");
        $("#productSelect").val(varId);
        let elem = document.getElementById("productSelect");
        elem.dispatchEvent(new Event("change"));
        $("#productPrice").text(var_price);
      }
    }
    changeMainImage();
    setSoldOut();
  });
});




